import { Square } from "../model/square.js";

export let path = [];

let offset = 1084;

let coordinates = [ [ 187, 1938 ], [ 265, 1921 ], [ 306, 1910 ], [ 356, 1905 ], [ 405, 1907 ], [ 455, 1910 ], [ 502, 1921 ], [ 549, 1932 ], [ 593, 1949 ], [ 648, 1946 ], [ 648, 1896 ], [ 620, 1855 ], [ 590, 1819 ], [ 549, 1792 ], [ 502, 1767 ], [ 458, 1768 ], [ 411, 1767 ], [ 361, 1770 ], [ 314, 1778 ], [ 265, 1789 ], [ 218, 1794 ], [ 165, 1797 ], [ 119, 1783 ], [ 110, 1731 ], [ 135, 1684 ], [ 179, 1665 ], [ 229, 1654 ], [ 273, 1643 ], [ 325, 1648 ], [ 372, 1654 ], [ 424, 1657 ], [ 469, 1654 ], [ 518, 1657 ], [ 568, 1648 ], [ 615, 1626 ], [ 615, 1579 ], [ 582, 1541 ], [ 554, 1502 ], [ 554, 1453 ], [ 593, 1417 ], [ 631, 1392 ], [ 631, 1342 ], [ 595, 1307 ], [ 549, 1306 ], [ 502, 1326 ], [ 463, 1351 ], [ 427, 1386 ], [ 400, 1428 ], [ 408, 1477 ], [ 433, 1524 ], [ 386, 1544 ], [ 334, 1535 ], [ 287, 1527 ], [ 240, 1510 ], [ 198, 1486 ], [ 157, 1461 ], [ 132, 1420 ], [ 121, 1370 ], [ 138, 1326 ], [ 185, 1301 ], [ 229, 1295 ], [ 278, 1296 ], [ 328, 1295 ], [ 375, 1284 ], [ 413, 1251 ], [ 455, 1224 ], [ 502, 1216 ], [ 549, 1207 ], [ 601, 1199 ], [ 615, 1155 ], [ 595, 1108 ], [ 549, 1092 ], [ 502, 1083 ], [ 455, 1078 ], [ 408, 1080 ], [ 358, 1094 ], [ 317, 1116 ], [ 278, 1149 ], [ 245, 1182 ], [ 196, 1191 ], [ 149, 1171 ], [ 119, 1136 ], [ 105, 1089 ], [ 113, 1039 ], [ 143, 1001 ], [ 190, 979 ], [ 237, 967 ], [ 284, 965 ], [ 336, 964 ], [ 383, 970 ], [ 430, 973 ], [ 482, 974 ], [ 526, 970 ], [ 576, 962 ], [ 617, 934 ], [ 609, 888 ], [ 579, 852 ], [ 554, 805 ], [ 560, 761 ], [ 598, 733 ], [ 637, 700 ], [ 626, 650 ], [ 590, 620 ], [ 540, 623 ], [ 496, 645 ], [ 455, 675 ], [ 419, 708 ], [ 394, 752 ], [ 411, 799 ], [ 427, 846 ], [ 372, 860 ], [ 325, 852 ], [ 276, 841 ], [ 234, 821 ], [ 190, 799 ], [ 154, 769 ], [ 132, 722 ], [ 121, 675 ], [ 146, 631 ], [ 193, 617 ], [ 243, 609 ], [ 287, 615 ], [ 336, 612 ], [ 383, 593 ], [ 424, 549 ] ]
for (let i = 0; i < coordinates.length; i++){
  coordinates[i][1] = coordinates[i][1] - offset;
}

for (let i = 0; i <= 124; i++) {
  if ([6, 18, 29, 42, 54, 70, 84, 102, 114].includes(i)) {
    path.push(
      new Square(
        i,
        new Phaser.Math.Vector2(coordinates[i][0], coordinates[i][1]),
        "magic-x2",
      ),
    );
  } else if ([12, 24, 36, 48, 62, 76, 90, 108, 120].includes(i)) {
    path.push(
      new Square(
        i,
        new Phaser.Math.Vector2(coordinates[i][0], coordinates[i][1]),
        "magic-x3",
      ),
    );
  } else if ([3, 15, 21, 33, 39, 45, 51, 57, 67, 73, 81, 87, 95, 99, 105, 111, 117].includes(i)) {
    path.push(
      new Square(
        i,
        new Phaser.Math.Vector2(coordinates[i][0], coordinates[i][1]),
        "bonus",
      ),
    );
  } else {
    path.push(
      new Square(
        i,
        new Phaser.Math.Vector2(coordinates[i][0], coordinates[i][1]),
        "basic",
      ),
    );
  }
}
